import cx from 'classnames';
import "./ModalActionBar.css";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ModalActionBar({
  children,
  className,
  tag: Tag = 'div'
}) {
  return /*#__PURE__*/_jsx(Tag, {
    className: cx('ModalActionBar', className),
    "data-sentry-element": "Tag",
    "data-sentry-component": "ModalActionBar",
    "data-sentry-source-file": "ModalActionBar.tsx",
    children: children
  });
}